/**
 * @flow
 * @author: Chinmaya
 */

import * as React from 'react'

import {
  DropdownContainer as BaseDropdownContainer,
  Dropdownlist as BaseDropdownList,
  DropdownItems as BaseDropdownItems,
  DropdownItemContainer
} from './styledComponents'

import {
  BUSINESS_SECTION,
  LEARNERS_SECTION,
  GAMEDEVELOPERS_SECTION
} from '../../constants/RouteConstants'

import {
  scrollToBusiness,
  scrollToGameDevelopers,
  scrollToLearners
} from '../../utils/navigationUtils'

type Props = {}

class StakeHoldersDropdown extends React.Component<Props> {
  render() {
    const {
      renderDropdownList: Dropdownlist,
      renderDropdownItems: DropdownItems,
      renderDropdownContainer: DropdownContainer,
      closeSideNavbar,
      isHome
    } = this.props
    return (
      <DropdownContainer {...this.props}>
        <Dropdownlist>
          {isHome ? (
            <DropdownItemContainer onClick={closeSideNavbar}>
              <DropdownItems>
                <button onClick={scrollToGameDevelopers}>
                  Game Developers
                </button>
              </DropdownItems>
            </DropdownItemContainer>
          ) : (
            <DropdownItemContainer onClick={closeSideNavbar}>
              <DropdownItems href={GAMEDEVELOPERS_SECTION}>
                <button>Game Developers</button>
              </DropdownItems>
            </DropdownItemContainer>
          )}
          {isHome ? (
            <DropdownItemContainer onClick={closeSideNavbar}>
              <DropdownItems>
                <button onClick={scrollToBusiness}>Businesses</button>
              </DropdownItems>
            </DropdownItemContainer>
          ) : (
            <DropdownItemContainer onClick={closeSideNavbar}>
              <DropdownItems href={BUSINESS_SECTION}>
                <button>Businesses</button>
              </DropdownItems>
            </DropdownItemContainer>
          )}
          {isHome ? (
            <DropdownItemContainer onClick={closeSideNavbar}>
              <DropdownItems>
                <button onClick={scrollToLearners}>Learners</button>
              </DropdownItems>
            </DropdownItemContainer>
          ) : (
            <DropdownItemContainer onClick={closeSideNavbar}>
              <DropdownItems href={LEARNERS_SECTION}>
                <button>Learners</button>
              </DropdownItems>
            </DropdownItemContainer>
          )}
        </Dropdownlist>
      </DropdownContainer>
    )
  }
}

StakeHoldersDropdown.defaultProps = {
  renderDropdownList: BaseDropdownList,
  renderDropdownContainer: BaseDropdownContainer,
  renderDropdownItems: BaseDropdownItems,
  isHome: false
}

export default StakeHoldersDropdown
